import React from 'react';
interface ConfidenceBandProps {
  value: number | null;
  showDivider?: boolean;
  compact?: boolean;
}
function bandColor(value: number): {
  bar: string;
  text: string;
} {
  if (value < 40) return {
    bar: 'bg-red-500',
    text: 'text-red-600 dark:text-red-400'
  };
  if (value < 70) return {
    bar: 'bg-amber-500',
    text: 'text-amber-600 dark:text-amber-400'
  };
  return {
    bar: 'bg-emerald-500',
    text: 'text-emerald-600 dark:text-emerald-400'
  };
}
export function ConfidenceBand({
  value,
  compact = false
}: ConfidenceBandProps) {
  if (value === null || value === undefined) {
    return <span className="text-xs text-slate-300 dark:text-[#444]" data-id="element-87">—</span>;
  }
  const {
    bar,
    text
  } = bandColor(value);
  return <div className="flex items-center gap-2" aria-label={`Confidence ${value} of 100`} data-id="element-88">
      <div className={`h-1.5 rounded-full bg-slate-100 dark:bg-[#2a2a2a] overflow-hidden ${compact ? 'w-12' : 'w-20'}`} data-id="element-89">
        <div className={`h-full rounded-full ${bar}`} style={{
        width: `${value}%`
      }} data-id="element-90" />
      </div>
      <span className={`text-xs font-semibold tabular-nums ${text}`} data-id="element-91">
        {value}
      </span>
    </div>;
}